
    <mat-dialog-content>
        <p><strong>{{data}}</strong></p>
    </mat-dialog-content>
    <mat-dialog-actions class="buttondiv" fxLayout="row" fxFlexAlign="stretch">
        <button class="yesButton" (click)="Confirm()">Ja</button>
        <button class="noButton"  (click)="Discline()">Nein</button>
    </mat-dialog-actions>

